<div class="w-full flex flex-col min-h-full">
    <app-header></app-header>
    <div class="w-full flex-1 flex [&>*:not(router-outlet)]:flex [&>*:not(router-outlet)]:flex-col [&>*:not(router-outlet)]:flex-1">
        <router-outlet />
    </div>
    <app-footer></app-footer>
</div>